import { ReservationTimelineTest } from 'domains/Reservation/Timeline'

export const reservationRoutes = [
  {
    path: '/test-component/reservation-timeline',
    component: ReservationTimelineTest
  }
]
